var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "responsive-image",
    class: {
      'responsive-image--zoomed': _vm.zoom,
      'responsive-image--cover': _vm.cover
    },
    style: _vm.wrapperStyle
  }, [_c('aspect-ratio-box', {
    class: {
      'bg-gray-150': _vm.backgroundColor
    },
    attrs: {
      "ratio": _vm.currentDimensions.ratio
    }
  }, [_c('img', _vm._b({
    ref: "image",
    staticClass: "responsive-img",
    class: [{
      'loading': _vm.isLoading
    }, _vm.roundedString],
    style: _vm.imageStyle,
    attrs: {
      "alt": _vm.alt,
      "width": _vm.currentDimensions.width,
      "height": _vm.currentDimensions.height
    }
  }, 'img', _vm.srcProps, false)), _vm._v(" "), _vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }